export default __webpack_public_path__ + "static/media/dog-silhouette-gray.41dd83fa.svg";